<script>
import Titre from "@/components/atoms/titre";
import Popin from "@/components/molecules/popin";
import Button from "@/components/atoms/button";

export default {
  name: "CarteFideliteRetrouverPorteur",
  components: {
    Popin,
    Titre,
    Button
  },
  props: {
    isEligibleDefis: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<template>
  <div>
    <!-- type button est essentiel car est utilisé dans des Form -->
    <Button
      link
      type="button"
      @click="$refs.porteurPopin.show()"
    >
      Comment retrouver le porteur de carte ?
    </Button>
    <Popin
      ref="porteurPopin"
      size="md"
      aria-label="Numero de fidelité"
    >
      <div class="u-flex u-flex-column u-flex-align-center">
        <Titre
          tag="h1"
          size="md"
          variant="primary"
          class="u-text-center u-mb-xs"
        >
          Trouver le nom et prénom du porteur de carte
        </Titre>
        <p>
          Si vous avez une carte Malin, rendez-vous au Village des Services de votre magasin muni de votre pièce d’identité, où vous pourrez mettre à jour les nom et prénom associés à votre carte.<br>
          <br>
          Si vous avez une carte cora Cpay Mastercard, les nom et prénom associés à la carte sont inscrits dessus.
        </p>
        <Button
          outline
          variant="primary"
          size="md"
          radius="full"
          class="u-mt-lg"
          @click="$refs.porteurPopin.hide()"
        >
          Fermer
        </Button>
      </div>
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
</style>
